import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { ConfirmationModal } from '../../../common/ConfirmationModal'
import { IBookingModel } from '../../../../interfaces/models/bookings.interfaces'
import { userQueries } from '../../../../api/users'
import { getUserFullName } from '../../../../helpers/user'

interface DeleteBookingConfirmationModalProps {
  showModal: boolean
  closeModal: () => void
  booking: IBookingModel
  onDelete: () => void
  loading?: boolean
  otherUsersOwnsBooking?: boolean
  disableCloseOnConfirm?: boolean
}

export const DeleteBookingConfirmationModal = ({
  showModal,
  closeModal,
  booking,
  otherUsersOwnsBooking,
  loading,
  onDelete,
  disableCloseOnConfirm,
}: DeleteBookingConfirmationModalProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { data: user } = useQuery(userQueries.getUser(booking.userId))

  return (
    <ConfirmationModal
      title={translate('facilityView.bookings.alert.deleteTitle')}
      description={
        otherUsersOwnsBooking
          ? translate(
              'facilityView.bookings.alert.deleteOtherUserBookingDescription',
              { name: getUserFullName(user) }
            )
          : translate('facilityView.bookings.alert.deleteDescription')
      }
      show={showModal}
      close={closeModal}
      onConfirm={onDelete}
      loading={loading}
      disableCloseOnConfirm={disableCloseOnConfirm}
      confirmationButtonLabel={translate(
        'facilityView.bookings.alert.deleteBookingButtonLabel'
      )}
    />
  )
}
